<template>
  <v-form ref="form" v-model="formValid" lazy-validation>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-select v-model="model.work"
                    item-text="label"
                    item-value="value"
                    required
                    :items="works"
                    :label="`app.interview.work` | trans"
                    return-object
                    clearable
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea
              :label="'app.interview.work_hours' | trans"
              v-model="model.work_hours"
              rows="4"
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-textarea
              :label="'app.interview.eating_habits' | trans"
              v-model="model.eating_habits"
              rows="4"
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-textarea
              :label="'app.interview.previous_diet' | trans"
              v-model="model.previous_diet"
              rows="4"
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-select v-model="model.stress"
                    item-text="label"
                    item-value="value"
                    required
                    :items="stresses"
                    :label="`app.interview.stress` | trans"
                    clearable
                    return-object
          ></v-select>
        </v-flex>
        <v-flex xs12 class="layout justify-center align-center">
          <v-autocomplete
              multiple
              clearable
              v-model="model.equipments"
              :items="equipments"
              item-text="name"
              item-value="id"
              :label="`app.interview.equipments` | trans"
              return-object
          >
          </v-autocomplete>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">help</v-icon>
            </template>
            <span v-html="trans('app.interview.equipments_description')"></span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12>
          <v-textarea
              :label="'app.interview.supplements' | trans"
              v-model="model.supplements"
              rows="4"
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider v-if="showSaveButton"></v-divider>
    <v-container fluid v-if="showSaveButton">
      <v-layout align-center justify-end>
        <v-btn @click="cancel()" :disabled="loading">{{ 'app.cancel' | trans }}</v-btn>
        <v-btn color="primary" @click="save()" :disabled="!formValid || loading" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import {trans} from "../../../app";
import {mapGetters, mapActions} from "vuex";
import {helpers} from "../../../helpers";

export default {
  props: {
    showSaveButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      model: {
        work: null,
        work_hours: null,
        eating_habits: null,
        previous_diet: null,
        stress: null,
        supplements: null,
      },
      formValid: false,
      loading: false,
      works: [
        {
          label: trans('app.interview.works.1'),
          value: 1,
        },
        {
          label: trans('app.interview.works.2'),
          value: 2
        }
      ],
      stresses: [
        {
          label: trans('app.interview.stresses.1'),
          value: 1,
        },
        {
          label: trans('app.interview.stresses.2'),
          value: 2
        }
      ],
      equipments: [],
    }
  },
  async created() {
    await this.fetchEquipments();
    this.loadModel();
  },
  computed: {
    ...mapGetters(['patient', 'interview'])
  },
  methods: {
    ...mapActions(['updateInterview']),
    async fetchEquipments() {
      try {
        const response = await axios.get('/v2/equipments');
        this.equipments = response.data;
      } catch (error) {
        this.sentryCaptureException(error);
      }
    },
    loadModel() {
      this.model.work = this.interview.work;
      this.model.work_hours = this.interview.work_hours;
      this.model.eating_habits = this.interview.eating_habits;
      this.model.previous_diet = this.interview.previous_diet;
      this.model.stress = this.interview.stress;
      this.model.supplements = this.interview.supplements;
      this.model.equipments = this.interview.equipments;
      this.$forceUpdate();
    },
    cancel() {
      this.loadModel();
      this.$emit('canceled');
    },
    async save() {
      this.loading = true;
      if (this.$refs.form.validate() === false) {
        this.loading = false;
        this.$toast.error(trans('app.save_failed'));
        return false;
      }

      let updatedInterview = helpers.deepClone(this.interview);
      updatedInterview.work_hours = this.model.work_hours;
      updatedInterview.eating_habits = this.model.eating_habits;
      updatedInterview.previous_diet = this.model.previous_diet;
      updatedInterview.supplements = this.model.supplements;
      updatedInterview.equipments = this.model.equipments;
      updatedInterview.work = this.model.work ? this.model.work.value : null;
      updatedInterview.stress = this.model.stress ? this.model.stress.value : null;

      try {
        await this.updateInterview(updatedInterview);
      } catch (error) {
        this.$toast.error(trans('app.save_failed'));
        this.loading = false;
        this.sentryCaptureException(error);
        return false;
      }

      this.loading = false;
      this.$toast.success(trans('app.actions.saved', {name: trans('app.patients.panel.interview').toLowerCase()}));
      this.$emit('saved');
      return true;
    }
  }
}
</script>